export class CookieManager {
    /**
     * Получить значение куки по имени
     */
    static get(name: string): string | null {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop()?.split(';').shift() || null;
        }
        return null;
    }

    /**
     * Установить куки
     */
    static set(name: string, value: string, options: {
        expires?: Date;
        path?: string;
        domain?: string;
        secure?: boolean;
        sameSite?: 'Strict' | 'Lax' | 'None';
    } = {}): void {
        let cookie = `${name}=${value}`;

        if (options.expires) {
            cookie += `; expires=${options.expires.toUTCString()}`;
        }
        if (options.path) {
            cookie += `; path=${options.path}`;
        }
        if (options.domain) {
            cookie += `; domain=${options.domain}`;
        }
        if (options.secure) {
            cookie += '; secure';
        }
        if (options.sameSite) {
            cookie += `; samesite=${options.sameSite}`;
        }

        document.cookie = cookie;
    }

    /**
     * Удалить куки
     */
    static remove(name: string, options: {
        path?: string;
        domain?: string;
    } = {}): void {
        this.set(name, '', {
            ...options,
            expires: new Date(0)
        });
    }

    /**
     * Проверить, есть ли куки с указанным именем
     */
    static has(name: string): boolean {
        return this.get(name) !== null;
    }

    /**
     * Получить все куки в виде объекта
     */
    static getAll(): Record<string, string> {
        const cookies: Record<string, string> = {};
        document.cookie.split(';').forEach(cookie => {
            const [name, value] = cookie.trim().split('=');
            if (name && value) {
                cookies[name] = value;
            }
        });
        return cookies;
    }
} 